import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withBgYellow50} from '@/hocs/withColors';
import {withMarginBottomSm, withMarginBottomXxl} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {H2, H3, P, PNoMargin} from '@/typography';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import Pill from '@/ui/pills';

const Yellow50Section = withBgYellow50(SectionPadding);
const PillMargined = withMarginBottomSm(Pill);
const MarginedSm = withMarginBottomSm('div');
const PmarginedXxl = withMarginBottomXxl(P);

const globalReachArray = [
  {
    shape: 'award',
    title: 'Award-winning technology',
    copy: 'Partner with Workable to get your clients access to the world’s leading hiring and HR platform. Get rewarded for getting your clients the very best HR software on the market.'
  },
  {
    shape: 'heart',
    title: 'Service and support',
    copy: 'Workable partners get access to expert service and support teams, extensive developer documentation and a partnerships team built to help you succeed.'
  },
  {
    shape: 'reach',
    title: 'Increase your reach',
    copy: 'Get your integration or service featured in our partner directory. Joining our rich partners ecosystem increases your visibility, product adoption, and ultimately revenue.'
  }
];

const GlobalReachSection = () => (
  <Yellow50Section>
    <Container>
      <Grid fluid>
        <Row center="xs">
          <Col xs={12} lg={6}>
            <PillMargined variant="neutral900">Global reach</PillMargined>
            <H2>Why partner with Workable?</H2>
            <PmarginedXxl>
              Thousands of companies around the world have used Workable to make millions of
              successful hires and manage their employees. Tap into our global client base and get
              your product and services in front of thousands of scaling businesses.
            </PmarginedXxl>
          </Col>
        </Row>
        <GridLayout Col={3} lgCol={2} autoRows>
          {globalReachArray.map((item, index) => (
            <GridItem key={index}>
              <BoxGrid backgroundColor="var(--yellow100)">
                <MarginedSm>
                  <img
                    src={`/static/images/partnership-program/partner-with-workable/${item.shape}-shape.svg`}
                    alt={`${item.title} icon`}
                    loading="lazy"
                  />
                </MarginedSm>
                <H3>{item.title}</H3>
                <PNoMargin>{item.copy}</PNoMargin>
              </BoxGrid>
            </GridItem>
          ))}
        </GridLayout>
      </Grid>
    </Container>
  </Yellow50Section>
);

export default GlobalReachSection;
